import { requestApi } from './Api';

export const getPayments = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/practice/billing/get_payments',
    params
  });

export const getTransactions = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/practice/billing/get_transactions',
    params
  });

export const createClaim = async (navigate, params) =>
  requestApi({ url: '/api/practice/billing/claim/create', params, navigate });

export const createMultipleClaims = async (navigate, params) =>
  requestApi({ url: '/api/practice/billing/claim/create_multiple', params, navigate });

export const getPaymentsCSV = async (navigate, params) =>
  requestApi({ navigate, url: '/api/practice/billing/get_payments_csv', params });

export const getInternalInvoices = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/practice/billing/invoicing/internal/get',
    params
  });

export const getOneInternalInvoice = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/practice/billing/invoicing/internal/get_one',
    params
  });

export const getInternalInvoicesCSV = (navigate, params) =>
  requestApi({ navigate, url: '/api/practice/billing/invoicing/internal/get_csv', params });

export const getExternalInvoices = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/practice/billing/invoicing/external/get',
    params
  });
export const getExternalInvoicesCSV = (navigate, params) =>
  requestApi({ navigate, url: '/api/practice/billing/invoicing/external/get_csv', params });

export const createExternalInvoices = (navigate, params) => {
  return requestApi({
    navigate,
    url: '/api/practice/billing/invoicing/external/create',
    params
  });
};

export const deleteExternalInvoices = (navigate, params) => {
  return requestApi({
    navigate,
    url: '/api/practice/billing/invoicing/external/delete',
    params
  });
};

export const getInternalInvoiceByIds = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/practice/billing/invoicing/external/get_internals',
    params
  });

export const getOldExternalsByAppointmentIds = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/practice/billing/invoicing/external/get_old_externals',
    params
  });

export const getIncomeIQueueAppointments = async (navigate, params) =>
  requestApi({ url: '/api/practice/billing/income_i_queue/get', navigate, params });

export const triggerIncomeIQueueActions = (navigate, params) =>
  requestApi({ url: '/api/practice/billing/income_i_queue/trigger_actions', navigate, params });

export const getIncomeIQueueExecutionSummary = (navigate, params) =>
  requestApi({
    url: '/api/practice/billing/income_i_queue/execution_summary',
    navigate,
    params
  });

export const resendIncomeIQueueMessage = (navigate, params) =>
  requestApi({
    url: '/api/practice/billing/income_i_queue/resend_message',
    navigate,
    params
  });

export const sendIncomeIQueueDeclineNotice = (navigate, params) =>
  requestApi({
    url: '/api/practice/billing/income_i_queue/send_decline_notice',
    navigate,
    params
  });

export const getIncomeIQueuePayerRules = (navigate, params) =>
  requestApi({
    url: '/api/practice/billing/income_i_queue/payer_rules',
    navigate,
    params
  });

export const getIncomeIQueueEligibilityChecks = (navigate, params) =>
  requestApi({
    url: '/api/practice/billing/income_i_queue/eligibility_checks',
    navigate,
    params
  });

export const resolveIncomeIQueuePayerRule = (navigate, params) =>
  requestApi({
    url: '/api/practice/billing/income_i_queue/resolve_payer_rule',
    navigate,
    params
  });

// The shared ActivitiesLog sends its filter chip as `type`; the endpoint filters on `category`.
export const getIncomeIQueueActivities = (navigate, { type, ...params } = {}) =>
  requestApi({
    url: '/api/practice/billing/income_i_queue/activity/get',
    navigate,
    params: { ...params, category: type }
  });

export const getBillingAndRenderingProviders = (navigate, params) =>
  requestApi({
    params,
    navigate,
    url: '/api/practice/billing/providers/get'
  });

export const sendToPatientPortal = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/practice/billing/invoicing/external/send_to_portal',
    params
  });

export const getPatientAging = (navigate, params) => {
  return requestApi({
    navigate,
    url: '/api/practice/billing/invoicing/internal/get_aging',
    params
  });
};

export const getOneExternalInvoice = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/practice/billing/invoicing/external/get_one',
    params
  });

export const assignPaymentToPatient = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/practice/billing/assign_patient',
    params
  });
